import React, { useState, useEffect, Fragment, useRef } from "react";
import { getEvents } from "services/getEvents";
import CardEvent from "components/cardEvento/cardEvent";
import './list.sass';
import Loading from "components/loading/loading";
import { LEGAL_PATROCINADOR_CALIENTE, LEGAL_PATROCINADOR_CODERE } from "constantes/constantes";
import Legal from "components/legal/legal";

export default function ListPrincipal({ flagMomios, url, patrocinador }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const principales = "principales";
  const automatico = "principales/principales_automatico";
  const manual = "principales/principales_manual";
  const semanal = "principales/principales_semanal";

  // obtener data para eventos
  useEffect(() => {
    const fetchData = async () => {
      let endpoint;
      const lowerUrl = String(url).toLowerCase();
      const lowerPrincipales = String(principales).toLowerCase();

      // 1. Si la URL contiene "principales" y principales === 'principales_unotv'
      if (lowerUrl.includes(principales) && lowerUrl.includes('principales_unotv')) {
        endpoint = "principales_unotv";
      }
      else if (lowerUrl.includes(lowerPrincipales)) {
        endpoint = semanal;
      } else {
        endpoint = url;
      }

      try {
        let response = await getEvents({ endpoint });
        let responseData = response.data;

        if (lowerUrl.includes('principales_semanal') && lowerPrincipales !== 'principales_unotv') {
          if (!responseData || responseData.length === 0 || responseData.length < 5) {
            endpoint = automatico;
            response = await getEvents({ endpoint });
            responseData = response.data;
          }
        }

        setLoading(false);
        setData(responseData);
      } catch (error) {
        console.error("Error al obtener los datos:", error);
      }
    };

    fetchData();
  }, []);

  //------- INICIAR EJECUCION DE REZISE DEL COMPONENTE -------
  const widgetoRef = useRef(null);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const newHeight = entry.contentRect.height;

        window.requestAnimationFrame(() => {
          const message = {
            sentinel: "amp",
            type: "embed-size",
            height: newHeight,
          };
          window.parent.postMessage(message, "*");
        });
      });
    });


    if (widgetoRef.current) {
      resizeObserver.observe(widgetoRef.current);

    }

    // Limpia el ResizeObserver al desmontar el componente
    return () => {
      resizeObserver.disconnect();
    };
  }, [widgetoRef]);
  //------- TERMINA EJECUCION DE REZISE DEL COMPONENTE -------

  return (
    <div className="container-sponsor" id="container-sponsor" ref={widgetoRef}>
      {loading
        ? <Loading />
        :
        <>
          <div className="container-list" >
            {data && data.length > 0 && data.map((item, indice) =>
              <Fragment key={item.id_juego}>
                <CardEvent item={item} flagMomios={flagMomios} patrocinador={patrocinador} />
              </Fragment>
            )}
          </div>

          {(flagMomios === true || flagMomios === "true") && !loading && (() => {
            const legalTextMap = {
              codere: LEGAL_PATROCINADOR_CODERE,
              caliente: LEGAL_PATROCINADOR_CALIENTE
            };

            const legalText = legalTextMap[patrocinador.toLowerCase()] || "";

            return legalText.trim().length > 0 ? <Legal patrocinador={patrocinador} /> : null;
          })()}
        </>
      }
    </div>
  )

}